import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../../UserPermissionsContext";
import { Spin } from "antd";

interface ErrorMessages {
  name?: string[];
}

const EditMetaOnBoardCategory = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
  });

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchCategoriesData = async () => {
    const resposne = await fetch(
      `${webApi}/meta_onboard/meta_onboard_ticket_category/${id}/`,
      options,
    );
    const data = await resposne.json();
    setData(data);
  };

  useEffect(() => {
    if (!checkPermission("change_metaonboardticketcategory", "metaonboardticketcategory")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchCategoriesData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(data),
    };
    const url = `${webApi}/meta_onboard/meta_onboard_ticket_category/${id}/`;
    const response = await fetch(url, requestOptions);
    const errorData = await response.json();

    if (!response.ok) {
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      setErrorMessage(errorData);
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.metaOnBoardCategories);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value || null });
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Meta Onboard Edit Category</h3>
                <ul className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li> */}
                  <li className="breadcrumb-item">
                    <Link to={routes.metaOnBoardCategories}>Categories</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Category</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form
                      onSubmit={handleSubmit}
                      className="d-flex flex-column"
                    >
                      <div className="modal-body light-violet-bg d-flex"></div>
                      <div className="form-group mb-3" style={{ width: "35%" }}>
                        <label className="form-label">Category Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.name ? "is-invalid" : ""
                          }`}
                          name="name"
                          placeholder="Category Name"
                          onChange={handleInputChange}
                          value={data.name || ""}
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          type="submit"
                          to={routes.metaOnBoardCategories}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMetaOnBoardCategory;
